module.exports = __webpack_public_path__ + "static/img/4.64f3dfc2.webp";